import React from 'react';
import { connect } from 'react-redux';
import * as usersActions from 'Store/users/actions';
import * as formsActions from 'Store/forms/actions';
import { sendInvitedTeachersEvent } from 'Store/stats/actions';
import * as reducers from 'Store/reducers';

import Form from 'Components/Form';

const formName = 'inviteMultipleTeachers';
class InviteMultipleTeachersForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.checkIfChangeWillExceedSeatLimit = this.checkIfChangeWillExceedSeatLimit.bind(
      this
    );
  }

  componentWillReceiveProps(nextProps) {
    const {
      invitedTeachersPosting,
      teachersInvitedCount,
      setFormAsSubmitted,
      isPosting,
    } = nextProps;
    if (
      teachersInvitedCount > 0 &&
      invitedTeachersPosting.length === 0 &&
      isPosting
    ) {
      setFormAsSubmitted(formName, formName);
    }
  }

  checkIfChangeWillExceedSeatLimit(emailAddresses) {
    const { seatLimit, teachers } = this.props;
    const existingEmails = teachers.map(teacher => {
      if (teacher.auth_info) return teacher.auth_info.username;
    });
    const newEmails = [];
    emailAddresses.map(email => {
      if (!existingEmails.includes(email)) newEmails.push(email);
    });
    return newEmails.length + teachers.length > seatLimit;
  }

  handleSubmit(fields, isFormValid) {
    const {
      submitForm,
      enableFormReconciliationMode,
      setFormMessageById,
      sendInvitedTeachersEvent,
    } = this.props;
    if (isFormValid) {
      const emailAddresses = fields.inviteMultipleTeachers__inviteList.value
        .split('\n')
        .filter(email => email.length > 0);
      if (this.checkIfChangeWillExceedSeatLimit(emailAddresses)) {
        setFormMessageById(formName, formName, 'errors.will_exceed_seat_limit');
      } else {
        sendInvitedTeachersEvent(emailAddresses.length.toString());
        submitForm(formName, formName, { emailAddresses });
      }
    } else {
      enableFormReconciliationMode(formName, formName);
    }
  }

  render() {
    return (
      <Form
        type={formName}
        id={formName}
        submitHandler={(fields, isFormValid) =>
          this.handleSubmit(fields, isFormValid)
        }
        formStyle="login"
        messagePosition="lightbox-internal"
        submitButtonType="primary"
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    isPosting: reducers.isFormPosting(state, formName),
    teachersInvitedCount: reducers.getTeachersInvitedCount(state),
    resultsByEmail: reducers.getInvitedTeachersResults(state),
    invitedTeachersPosting: reducers.getInvitedTeachersPosting(state),
    user: reducers.getResetPasswordUser(state),
    teachers: reducers.getTeachersForActiveSchool(state),
    seatLimit: reducers.getActiveSchoolSeatLimit(state, 'teachers'),
  };
};

export default connect(mapStateToProps, {
  ...usersActions,
  ...formsActions,
  sendInvitedTeachersEvent,
})(InviteMultipleTeachersForm);
